import React from 'react';
import ModuleDetailByApi from './ModuleDetailByApi';

const ModuleDetailSwitch = () => <ModuleDetailByApi />;

export default ModuleDetailSwitch;
